import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { UncompleteItem } from '../../../types/personShow';
import { fetchUncompletedProfiles } from '../../../services/personProfiles';

type Props = {
  personId: number;
};

export const Component: FunctionComponent<Props> = ({
  personId,
}) => {
  const [uncompletes, setUncompletes] = useState<UncompleteItem[]>([]);

  useEffect(() => {
    const request = async () => {
      try {
        const response = await fetchUncompletedProfiles(personId);
        setUncompletes(response.uncompletes);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [personId]);

  const isLastIndex = (index: number) => index === uncompletes.length - 1;

  return <Presentation uncompletes={uncompletes} isLastIndex={isLastIndex} />;
};
